import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.ends-with.js";
import { defineComponent as _defineComponent } from 'vue';
import useImagePath from '~/composables/useImagePath';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzImg',
  props: {
    src: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: false,
      default: ''
    },
    resizeType: {
      type: String,
      required: false,
      default: 'c_fit',
      validator: function validator(value) {
        return ['c_auto', 'c_scale', 'c_fill', 'c_crop', 'c_fit'].includes(value);
      }
    },
    loading: {
      type: String,
      required: false,
      default: 'lazy',
      validator: function validator(value) {
        return ['lazy', 'eager'].includes(value);
      }
    },
    microdata: {
      type: Boolean,
      required: false,
      default: false
    },
    styles: {
      type: [String, Object, Array],
      required: false,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: 'none'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      $config = _useNuxt2App.$config;
    var isError = ref(false);
    var isLoaded = ref(false);
    var imagePath = computed(function () {
      return useImagePath(props.src);
    });
    var dimensions = computed(function () {
      var size = props.size || '';
      return size.toLowerCase();
    });
    var imgWidth = computed(function () {
      var _parseInt;
      return (_parseInt = parseInt(dimensions.value.split('x')[0])) !== null && _parseInt !== void 0 ? _parseInt : null;
    });
    var imgHeight = computed(function () {
      var _parseInt2;
      return (_parseInt2 = parseInt(dimensions.value.split('x')[1])) !== null && _parseInt2 !== void 0 ? _parseInt2 : null;
    });
    var imgInterval = computed(function () {
      return imgWidth.value < 200 ? 50 : 200;
    });
    var aspectRatio = computed(function () {
      return imgWidth.value && imgHeight.value ? "".concat(imgWidth.value, " / ").concat(imgHeight.value) : '';
    });
    var backgroundColor = computed(function () {
      if (props.backgroundColor === 'none') {
        return 'b_none';
      } else {
        // We assume an RGB/HEX value
        return "b_rgb:".concat(props.backgroundColor);
      }
    });
    var imgSrc = computed(function () {
      if ($config.public.cloudinaryDomain && imagePath.value) {
        if (imgWidth.value) {
          return props.resizeType === 'c_fill' ? imgSrcForFillCrop.value : imgSrcForGenericCrop.value;
        } else {
          return "".concat($config.public.cloudinaryDomain, "/d_default_placeholder.png/c_limit,q_auto,f_auto,w_2000/").concat(backgroundColor.value, "/v1/").concat(imagePath.value);
        }
      } else {
        return "".concat(require('~/assets/images/error/generic_img.png'));
      }
    });
    var imgSrcForGenericCrop = computed(function () {
      return "".concat($config.public.cloudinaryDomain, "/d_default_placeholder.png/").concat(props.resizeType, ",q_auto,f_auto,w_").concat(imgWidth.value, "/").concat(backgroundColor.value, "/v1/").concat(imagePath.value);
    });
    var imgSrcForFillCrop = computed(function () {
      return "".concat($config.public.cloudinaryDomain, "/d_default_placeholder.png/c_fill,q_auto,f_auto,w_").concat(imgWidth.value, ",h_").concat(imgHeight.value, "/").concat(backgroundColor.value, "/v1/").concat(imagePath.value);
    });
    var imgSrcset = computed(function () {
      if (isError.value) return '';
      return props.resizeType === 'c_fill' ? imgSrcsetForFillCrop.value : imgSrcsetForGenericCrop.value;
    });
    var imgSrcsetForGenericCrop = computed(function () {
      if (isError.value) return '';
      var currentWidth = imgWidth.value * 2;
      var srcset = [];
      while (currentWidth > 0) {
        var src = "".concat($config.public.cloudinaryDomain, "/d_default_placeholder.png/").concat(props.resizeType, ",q_auto,f_auto,w_").concat(currentWidth, "/").concat(backgroundColor.value, "/v1/").concat(imagePath.value, " ").concat(currentWidth, "w");
        srcset.push(src);
        currentWidth = currentWidth - imgInterval.value;
      }
      return srcset.join(',');
    });
    var imgSrcsetForFillCrop = computed(function () {
      var currentWidth = imgWidth.value * 2;
      var currentHeight = imgHeight.value * 2;
      var srcset = [];
      while (currentWidth > 0 && currentHeight > 0) {
        var src = "".concat($config.public.cloudinaryDomain, "/d_default_placeholder.png/c_fill,q_auto,f_auto,w_").concat(currentWidth, ",ar_").concat(imgWidth.value, ":").concat(imgHeight.value, "/").concat(backgroundColor.value, "/v1/").concat(imagePath.value, " ").concat(currentWidth, "w");
        srcset.push(src);
        currentWidth = currentWidth - imgInterval.value;
        currentHeight = currentHeight - imgInterval.value;
      }
      return srcset.join(',');
    });
    var backgroundImage = computed(function () {
      var _props$src;
      if ((_props$src = props.src) !== null && _props$src !== void 0 && _props$src.endsWith('.svg') || isLoaded.value || isError.value) return '';
      var imageHeight = isNaN(imgHeight.value) ? 528 : imgHeight.value;
      var imageWidth = isNaN(imgWidth.value) ? 528 : imgWidth.value;
      if ($config.public.cloudinaryDomain && imagePath.value) {
        return "url(".concat($config.public.cloudinaryDomain, "/d_default_placeholder.png/c_crop,g_north_east,h_10,w_10/ar_").concat(imageWidth, ":").concat(imageHeight, ",b_auto,c_pad/e_blur:800/f_auto,q_auto/").concat(backgroundColor.value, "/v1/").concat(imagePath.value, ")");
      } else {
        return "url(".concat(require('~/assets/images/error/generic_img.png'), ")");
      }
    });
    return {
      __sfc: true,
      props: props,
      $config: $config,
      isError: isError,
      isLoaded: isLoaded,
      imagePath: imagePath,
      dimensions: dimensions,
      imgWidth: imgWidth,
      imgHeight: imgHeight,
      imgInterval: imgInterval,
      aspectRatio: aspectRatio,
      backgroundColor: backgroundColor,
      imgSrc: imgSrc,
      imgSrcForGenericCrop: imgSrcForGenericCrop,
      imgSrcForFillCrop: imgSrcForFillCrop,
      imgSrcset: imgSrcset,
      imgSrcsetForGenericCrop: imgSrcsetForGenericCrop,
      imgSrcsetForFillCrop: imgSrcsetForFillCrop,
      backgroundImage: backgroundImage
    };
  }
});